// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 453 ? "eef9e134" : chunkId) + "." + {"24":"e349e739a2c14c5f","54":"35908394b9f89e3b","178":"6556961d1dfc90f1","401":"f2945eeb184f7258","453":"7e9867cf4fa5ef64","520":"c05e67bca86818f5","640":"dd3b416293bff626","701":"b5555051974d29ea","754":"9a572a6e55e120cb"}[chunkId] + ".js";
};